export default {
  'Custom': 'Personalizado',
  'Original': 'Original',
  'Resolution': 'Resolución',
  'Frame rate': 'Fotogramas por segundo',
  'The higher the frame rate, the smoother the animation': "Cuanto mayor sea la velocidad de fotogramas, más suave será la animación.",
  'Start': 'Inicio',
  'End': 'Fin',
  'Create GIF': 'Crear GIF',
  'Download GIF': 'Descargar GIF',
  'Create A New One': 'Crear un nuevo GIF',
  'Remake GIF': 'Rehacer GIF',
  'HitPaw Video to GIF Online': 'Convertir Video a Gif Online con HitPaw',
  'Upload and convert video to GIF without any difficulty': 'Sube y convierte videos a GIF sin ninguna dificultad',
}